<main class="theme4d">
  <header [class.no-background]="titleLink" [class.can-close]="canClose">
    @if (titleLink || canNavigateBack || canClose) {
      <div (click)="navigate()" class="can-click title">
        @if (canNavigateBack) {
          <i class="mdi mdi-chevron-left"></i>
          }@if (logo) {
          <span><img
          src="assets/svg/elogbooks-logo.svg" width="28px" height="28px"> </span>
          } {{label}}
        </div>
      }
      @if (canClose) {
        <div (click)="close()" class="can-click"><i class="fa fa-fw fa-times"></i></div>
      }
      @if (!titleLink && !canNavigateBack && !canClose) {
        <div class="title">{{label}}</div>
      }
    </header>

    <ng-content></ng-content>
  </main>